import { render, staticRenderFns } from "./ActView.vue?vue&type=template&id=972719a4&"
import script from "./ActView.vue?vue&type=script&lang=ts&"
export * from "./ActView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports